import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getText } from 'misc/helpers';

class TagFolder extends Component {
    render = () => {
        // Show right colored folder
        let folderImage = '';
        let colorIndex = (this.props.order) % 4;
        switch (colorIndex) {
            case 0:
                folderImage = 'assets/images/archives/folder_yellow.svg';
                break;
            case 1:
                folderImage = 'assets/images/archives/folder_orange.svg';
                break;
            case 2:
                folderImage = 'assets/images/archives/folder_pink.svg';
                break;
            case 3:
                folderImage = 'assets/images/archives/folder_blue.svg';
                break;
            default:
                folderImage = 'assets/images/archives/folder_yellow.svg';
        }

        return (
            <div className="folder" onClick={this.props.onClick}>
                <img src={folderImage} alt="" />
                <h3>{this.props.title}</h3>
                <span>
                    {this.props.count} {getText('Missing', 'brev')}
                </span>
            </div>
        );
    };
}

export default connect()(TagFolder);



// WEBPACK FOOTER //
// ./src/components/archives/TagFolder.js